<template>
  <div class="exhibition-block">
    <div class="exhibition" v-for="item in data" :key="item.id" @click="$store.dispatch('joinBooth', item.id)">
      <div class="exhibition-header">
        <img class="exhibition-cover" v-if="item.cover != null" :src="$imageus + item.cover + '?width=460&height=205&mode=cover'" alt="" />
        <img class="session-header" v-if="item.cover == null" src="/static/1120x500.png" alt="" />

        <div class="exhibition-logo">
          <div class="logo" :style="'background-image: url(' + $imageus + item.image + '?width=150&height=150&mode=cover)'"></div>
        </div>
      </div>

      <div class="exhibition-card">
        <div class="exhibition-left">
          <div class="exhibition-info" v-if="item.saloonID != null">
            <span>● {{ currentBoothSaloons.find(x => x.id == item.saloonID) ? currentBoothSaloons.find(x => x.id == item.saloonID).title : '' }}</span>
          </div>

          <div class="exhibition-title" v-if="item.title != null">
            <p>{{ item.title }}</p>
          </div>
        </div>

        <div class="exhibition-right">
          <el-button :icon="$store.state.sessionLoadingID != item.id ? 'fas fa-angle-right': 'fas fa-spinner spin'" :style="{ backgroundColor: currentEvent.color }" size="mini" circle></el-button>
            <!-- <span v-if="$store.state.sessionLoadingID != item.id"><i class="fa fa-angle-right"></i></span>
            <span v-if="$store.state.sessionLoadingID == item.id"><i class="fa fa-spinner spin"></i></span> -->
            <!-- <md-progress-spinner style="transition: 0s !important;" v-if="$store.state.sessionLoadingID == item.id" class="md-accent" :md-diameter="15" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment/min/moment-with-locales";
import axios from "axios";
export default {
  name: "ExhibitionBlock",
  props: ["data"],
  data() {
    return {
      moment
    };
  },
  methods: {},
  computed: {
    currentEvent() {
      return this.$store.getters.getEvent;
    },
    currentBoothSaloons() {
      return this.$store.getters.getBoothSaloons;
    }
  }
};
</script>

<style lang="less">
.exhibition-block {
  cursor: pointer;
  display: contents;

  .exhibition {
    width: 100%;
    position: relative;

    h4,
    h5 {
      margin: 0;
    }

    .exhibition-header {
      width: 100%;
      position: relative;

      .exhibition-cover {
        width: 100%;
        height: auto;
        border-top-right-radius: 8px;
        border-top-left-radius: 8px;
        box-shadow: rgba(0, 0, 0, 0.16) 0px 0px 3px;
      }

      .exhibition-logo {
        position: absolute;
        bottom: 10px;
        left: 12px;

        .logo {
          border: 2px solid #fff;
          border-radius: 8px;
          background-color: #fff;
          background-size: cover;
          background-position: 50%;
          width: 55px;
          height: 55px;
          background-repeat: no-repeat;
          box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.2);
        }
      }
    }

    .exhibition-card {
      justify-content: space-around;
      flex-direction: row;
      align-items: center;
      display: flex;
      background-color: #fff;
      padding: 8px 10px;
      // border: 0.5px solid #D6D9D9;
      box-shadow: rgba(0, 0, 0, 0.16) 0px 0px 3px;
      border-top: none;
      border-bottom-right-radius: 8px;
      border-bottom-left-radius: 8px;

      .exhibition-left {
        display: flex;
        flex: 1;
        flex-direction: column;
        justify-content: center;
        margin-left: 6px;

        .exhibition-info {
          margin: 0px;

          span {
            color: #8c929c;
            font-size: 12px;
            font-weight: 500;
            img {
              width: 12px;
              height: 12px;
              margin-right: 6px;
            }
          }
        }

        .exhibition-title {
          line-height: 16px;
          display: inline-grid;

          p {
            text-overflow: ellipsis;
            max-width: 240px !important;
            white-space: nowrap;
            overflow: hidden;
            margin: 0px;
            display: block;
            color: #292f3b;
            font-weight: 500;
            font-size: 14px;
          }
        }
      }

      .exhibition-right {
        flex-shrink: 0;
        .el-button {
          flex-shrink: 0;
          font-family: "Roboto";
          color:#fff;
          border: none;
          outline: none;
          width: 26px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/ExhibitionBlock.vue